import React from 'react';
import "../../css/Home.css";

const LandingPage = () => {
  return (
    <div className="abt-us-main-div">
      <video
        className="about-us-video"
        autoPlay
        loop
        muted
        playsInline
        poster="/images/MBZ-transport-main.jpg"
        controlsList="nodownload nofullscreen noremoteplayback"
        disablePictureInPicture
      >
        <source src="https://res.cloudinary.com/dqjsq4btr/video/upload/v1740987145/LogisticsIntroVideo_xxgwat.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="hero-overlay">
        <div className="hero-content">
          <h2 id="headingabtus">Connect your business<br />with the world</h2>
          <h5 id="descriptionabtus">
            One stop solution for all your logistics needs.<br />
            Seamless freight solutions for a moving world —<br />
            it's your shipment, but our priority.
          </h5>
          <div className="button-wrapper">
            <a href="#headingfreightforwarding" className="button-home-front">View our services</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
